import API from "../../../../../global/api";
import _ from "lodash";


export const requestAddLevelFour = () => {
    return {
        type: "REQUEST_ADD_LEVELFOUR",
    };
};
export const successAddLevelFour = (data) => {
    return {
        type: "SUCCESS_ADD_LEVELFOUR",
        payload: data,
    };
};
export const errorAddLevelFour = () => {
    return {
        type: "ERROR_ADD_LEVELFOUR",
    };
};
export const AddLevelFourApi = (data, showSuccessAlert, showErrorAlert) => {
    return (dispatch) => {
        dispatch(requestAddLevelFour());
        API.post(`/levelFour/add_levelFour`, data).then((res) => {
            dispatch(successAddLevelFour(data));
            showSuccessAlert(res.data.message);
        }).catch((error) => {
            dispatch(errorAddLevelFour());
            showErrorAlert(error.response.data.message || "Something went wrong");
        })
    };
};


export const requestGetLevelFourDropDown = () => {
    return {
        type: "REQUEST_GET_LEVELFOUR_DROPDOWN",
    };
};
export const successGetLevelFourDropDown = (data) => {
    return {
        type: "SUCCESS_GET_LEVELFOUR_DROPDOWN",
        payload: data,
    };
};
export const errorGetLevelFourDropDown = () => {
    return {
        type: "ERROR_GET_LEVELFOUR_DROPDOWN",
    };
};
export const GetLevelFourDropDownApi = () => {
    return (dispatch) => {
        dispatch(requestGetLevelFourDropDown());
        API.get(`/levelFour/get-selector-accounts`).then((res) => {
            let getData = res.data;
            dispatch(successGetLevelFourDropDown(getData));
        }).catch((error) => {
            dispatch(errorGetLevelFourDropDown());
        })
    };
};


export const requestGetAccountType = () => {
    return {
        type: "REQUEST_GET_ACCOUNT_TYPE",
    };
};
export const successGetAccountType = (data) => {
    return {
        type: "SUCCESS_GET_ACCOUNT_TYPE",
        payload: data,
    };
};
export const errorGetAccountType = () => {
    return {
        type: "ERROR_GET_ACCOUNT_TYPE",
    };
};
export const GetLevelAccountTypeApi = () => {
    return (dispatch) => {
        dispatch(requestGetAccountType());
        API.get(`/levelFour/credit_debit`).then((res) => {
            let getData = res.data;
            dispatch(successGetAccountType(getData));
        }).catch((error) => {
            dispatch(errorGetAccountType());
        })
    };
};


export const requestUploadLevelFourFile = () => {
    return {
        type: "REQUEST_UPLOAD_LEVELFFOUR_FILE",
    };
};
export const successUploadLevelFourFile = (data) => {
    return {
        type: "SUCCESS_UPLOAD_LEVELFFOUR_FILE",
        payload: data,
    };
};
export const errorUploadLevelFourFile = () => {
    return {
        type: "ERROR_UPLOAD_LEVELFOUR_FILE",
    };
};
export const UploadLevelFourFileApi = (data, handleVisible, handleDangerVisible) => {
    const formData = new FormData();
    formData.append("levelOneId", `${data.levelOneId}`);
    formData.append("levelTwoId", `${data.levelTwoId}`);
    formData.append("levelThreeId", `${data.levelThreeId}`);
    formData.append("file", _.get(data, 'file'));

    return (dispatch) => {
        dispatch(requestUploadLevelFourFile());
        API.post(`/levelFour/upload_levelFour`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((res) => {
            dispatch(successUploadLevelFourFile(data));
            handleVisible(res.data.message);
        }).catch((error) => {
            dispatch(errorUploadLevelFourFile());
            handleDangerVisible(error.response.data.message);
        });
    };
};


export const requestLevelFourView = () => {
    return {
        type: "REQUEST_LEVELFOUR_VIEW",
    };
};
export const successLevelFourView = (data) => {
    return {
        type: "SUCCESS_LEVELFOUR_VIEW",
        payload: data,
    };
};
export const errorLevelFourView = () => {
    return {
        type: "ERROR_LEVELFOUR_VIEW",
    };
};
export const LevelFourViewApi = () => {
    return (dispatch) => {
        dispatch(requestLevelFourView());
        API.get(`/levelFour/get_levelFour_details`).then((res) => {
            let getData = res.data;
            dispatch(successLevelFourView(getData));
        }).catch((error) => {
            dispatch(errorLevelFourView());
        })
    };
};


export const DeleteRequestLevelFour = () => {
    return {
        type: "DELETE_REQUEST_LEVEL_FOUR",
    };
};
export const DeleteSuccessLevelFour = (level_id) => {
    return {
        type: "DELETE_SUCCESS_LEVEL_FOUR",
        level_id: level_id,
    };
};
export const DeleteErrorLevelFour = () => {
    return {
        type: "DELETE_ERROR_LEVEL_FOUR",
    };
};
export const DeleteLevelFourApi = (levelFourId) => {
    return dispatch => {
        dispatch(DeleteRequestLevelFour());
        API.delete(`/levelFour/delete_levelFour/${levelFourId}`).then(res => {
            dispatch(LevelFourViewApi());
            dispatch(DeleteSuccessLevelFour(levelFourId))
        }).catch((error) =>
            dispatch(DeleteErrorLevelFour()));
    }
};


export const UpdateRequestLevelFour = () => {
    return {
        type: "UPDATE_REQUEST_LEVEL_FOUR",
    };
};
export const UpdateSuccessLevelFour = (level_id) => {
    return {
        type: "UPDATE_SUCCESS_LEVEL_FOUR",
        level_id: level_id,
    };
};
export const UpdateErrorLevelFour = () => {
    return {
        type: "UPDATE_ERROR_LEVEL_FOUR",
    };
};
export const UpdateLevelFourApi = (data, oldData) => {
    return dispatch => {
        dispatch(UpdateRequestLevelFour());
        API.put(`/levelFour/update_levelFour/${oldData._id}`, {
            levelFourName: _.toUpper(data.levelFourName),
            openingBalance: data.openingBalance,
        }, {
        }).then(res => {
            dispatch(LevelFourViewApi());
            dispatch(UpdateSuccessLevelFour([data]))
        }).catch((error) => {
            dispatch(UpdateErrorLevelFour());
        })
    }
};